<template>
  <ValidationProvider :name="id" :rules="validationRules" v-slot="{ errors }">
    <div :data-qa="`form-${id}--wrapper`">
      <b-field
        custom-class="z-u-text-label"
        :label="labelText"
        :type="{ 'is-danger': errors[0] }"
        :message="[errors[0] ? errorText : '']"
        :data-qa="`form-${id}--label`">
        <b-input
          v-model="value"
          :type="inputType"
          :id="id"
          :placeholder="placeholderText"
          autocomplete="off"
          @blur="handleBlur"
          @input="inputChanged"
          size="is-medium"
          data-hj-suppress
          :disabled="disabled"
          :data-qa="`form-${id}--input`"/>
      </b-field>
    </div>
  </ValidationProvider>
</template>
<script>
export default {
  name: 'Input',
  props: {
    errorText: {
      type: String
    },
    id: {
      type: String,
      required: true
    },
    inputModel: {
      type: String,
      required: true
    },
    validationRules: {
      type: String
    },
    inputType: {
      type: String,
      required: true
    },
    labelText: {
      type: String,
      required: true
    },
    placeholderText: {
      type: String
    },
    trimInput: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: this.inputModel // Needed so we don't mutate a prop
    }
  },
  methods: {
    inputChanged () {
      this.$emit('update:inputModel', this.trimInput ? this.value.trim() : this.value)
    },
    handleBlur (event) {
      if (this.trimInput) {
        this.value = event.target.value.trim()
        this.$emit('update:inputModel', this.value)
      }
    }
  },
  // Reactive binding for inputModel
  watch: {
    inputModel: function (newVal, oldVal) {
      this.value = newVal
    }
  }
}
</script>
